import React, { useEffect, useState } from 'react';
import '../style/Contact.css';
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { MdAccessTimeFilled } from "react-icons/md";

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [ville, setVille] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector('.contact-section');
      if (section) {
        const scrollPosition = window.scrollY + 300;
        const sectionTop = section.offsetTop;
        if (scrollPosition >= sectionTop) {
          setIsVisible(true);
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Gestion du formulaire vers WhatsApp
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!nom || !email || !ville || !message) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    const phoneNumber = '237651612451';

    const whatsappMessage = `Bonjour Beverly Hills Construction,%0A%0AJ'ai une demande de devis.%0A%0ANom : ${nom}%0AEmail : ${email}%0ATéléphone : ${telephone || 'Non renseigné'}%0AVille : ${ville}%0AMessage : ${message}%0A%0ACordialement.`;

    window.open(`https://wa.me/${phoneNumber}?text=${whatsappMessage}`, '_blank');

    // Réinitialiser le formulaire
    setNom('');
    setEmail('');
    setTelephone('');
    setVille('');
    setMessage('');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        {/* En-tête */}
        <div className={`contact-header ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          <h2>Nous contacter</h2>
          <div className="separator"></div>
          <p>Pour tout devis ou renseignement</p>
        </div>

        {/* Coordonnées + Formulaire */}
        <div className={`contact-content ${isVisible ? 'fade-in-up delay-1' : 'opacity-0'}`}>
          <div className="contact-info">
            <h3>Nos coordonnées</h3>
            <p><FaLocationDot /> Denver à Douala Cameroun</p>
            <p><FaPhone /> +237 6 51 61 24 51 | 6 50 08 07 21</p>
            <p><IoIosMail /> contact@beverlyhillsconstruction.com</p>
            <p><MdAccessTimeFilled /> Lundi-Vendredi: 8h-17h</p>
            <p style={{ paddingLeft: '32px' }}>Samedi: 8h-14h</p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nom complet *"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email *"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="tel"
              placeholder="Téléphone"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
            />
            <input
              type="text"
              placeholder="Ville *"
              value={ville}
              onChange={(e) => setVille(e.target.value)}
              required
            />
            <textarea
              placeholder="Votre message *"
              rows="5"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
            <button type="submit" className="btn-submit">
              Envoyer via WhatsApp
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;